module.exports = __webpack_public_path__ + "static/media/blog-image-1.78f77e63.jpg";